<template>
  <div id="wallet_container"></div>
</template>

<script>
const mp = new MercadoPago('APP_USR-2c8b9b3c-49a5-40ba-827a-accebd2cc8c3');
const bricksBuilder = mp.bricks();

export default {
  components: {
  },
  computed: {
  },
  data () {
    return {
    }
  },
  methods: {
    loadMercadoPago() {
      mp.bricks().create("wallet", "wallet_container", {
        initialization: {
          preferenceId: "<PREFERENCE_ID>"
        },
        customization: {
          texts: {
            valueProp: 'smart_option'
          }
        }
      });
    }
  },
  created () {
  }
}
</script>

<style lang="less" scoped>
</style>
